import dJSON from 'dirty-json';

const moduleSelector = '.cat-box';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.cat-box-grid').insertAdjacentHTML('beforeend', /* html */ `
          ${item.link ? /* html */ `<a class="cat-box-item" href="${item.link}">` : '<div class="cat-box-item">'}
            <div class="image-wrapper">
            ${item.background ? /* html */ `<img src="${item.background}" alt="" aria-hidden="true" role="presentation">` : ''}
              ${item.icon ? /* html */ `
                <div class="icon-wrapper">
                  <img src="${item.icon}" alt="" aria-hidden="true" role="presentation">
                </div>
              ` : ''}
            </div>
            <div class="details">
              ${item.title ? /* html */ `<h2 class="title">${item.title}</h2>` : ''}
              ${item.text ? /* html */ `<p class="text">${item.text}</p>` : ''}
              ${item.button ? /* html */ `<button href="${item.link}" class="btn-custom primary">${item.button}</button>` : ''}
            </div>
          ${item.link ? '</a>' : '</div>'}
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
